import dynamic from 'next/dynamic';
import { TravelInsuranceWidgetProps } from './TravelInsuranceWidget.types';

export const TravelInsuranceWidget = dynamic<TravelInsuranceWidgetProps>(
  () => import('./TravelInsuranceWidget').then(module => module.TravelInsuranceWidget),
  { ssr: false }
);
